import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import ManagementHistoryChanges from '@/frontend/features/Fde/ManagementHistoryChanges'
import type { ManagementHistoryCopy, ManagementHistoryEntry } from '@/frontend/features/Fde/projectManagementHistoryTypes'

export default function ProjectHistoryDetail({ entry, copy, onBack }: {
  entry: ManagementHistoryEntry; copy: ManagementHistoryCopy; onBack: () => void
}) {
  return <article aria-label={copy.selected_update} className="h-full overflow-y-auto overscroll-contain px-6 py-5 md:px-8 md:py-7">
    <Button variant="ghost" size="sm" onClick={onBack} className="mb-5 -ml-2 gap-1.5 px-2 text-xs md:hidden"><ArrowLeft className="size-3.5" />{copy.back}</Button>
    <header className="mb-7 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-muted-foreground">
      <time dateTime={entry.occurred_at}>{format(parseISO(entry.occurred_at), "d 'de' MMMM 'de' yyyy 'às' HH:mm", { locale: ptBR })}</time>
      <span aria-hidden="true">·</span><span>{entry.actor_name}</span>
    </header>
    {entry.progress ? <div className="space-y-7">
      <section><h3 className="mb-2 text-xs font-medium text-muted-foreground">{copy.next_step}</h3>
        <p className="whitespace-pre-wrap break-words text-lg font-medium leading-7 tracking-tight">{entry.progress.next_step || copy.no_step}</p>
      </section>
      <section><h3 className="mb-2 text-xs font-medium text-muted-foreground">{copy.latest_update}</h3>
        <p className="whitespace-pre-wrap break-words text-sm leading-6">{entry.progress.latest_update || copy.no_advance}</p>
      </section>
    </div> : <div>
      <p className="mb-2 text-xs text-muted-foreground">{copy[`category_${entry.category}`]} · {entry.action}</p>
      <h3 className="mb-6 break-words text-lg font-medium leading-7 tracking-tight">{entry.headline}</h3>
      <dl className="space-y-5">{entry.changes.map(change => <div key={change.field}>
        <dt className="mb-1 text-xs font-medium text-muted-foreground">{change.label}</dt>
        <dd className="whitespace-pre-wrap break-words text-sm leading-6">{entry.removed ? change.before : change.after}</dd>
      </div>)}</dl>
    </div>}
    <div className="mt-8 border-t border-border pt-4"><ManagementHistoryChanges entry={entry} copy={copy} /></div>
  </article>
}
